// Phát hiện từ đệm (filler words) — tiếng Việt + tiếng Anh.

const FILLERS = new Set([
  // English
  'um', 'uh', 'erm', 'er', 'ah', 'eh', 'hmm', 'mm', 'mhm', 'uhh', 'umm',
  'like', 'basically', 'literally', 'actually',
  // Vietnamese
  'ừm', 'ừ', 'à', 'ờ', 'ơ', 'ừa', 'ừm', 'thì', 'kiểu', 'ý', 'thế', 'ừm',
  'ừ thì', 'kiểu như', 'ý là', 'đấy', 'ấy', 'nhé', 'ừ ừ',
])

/** Chuẩn hóa: bỏ dấu câu, viết thường, cắt khoảng trắng. */
function normalize(text: string): string {
  return text
    .toLowerCase()
    .replace(/[.,!?;:"'""''(){}\[\]…\-–—]/g, '')
    .trim()
}

/** true nếu từ này là từ đệm. */
export function isFillerWord(text: string): boolean {
  const n = normalize(text)
  if (!n) return false
  return FILLERS.has(n)
}
